<template>
  <v-container fluid fill-height pa-0 ma-0 class="test_red pageBg">
    <v-row
      no-gutters
      justify="center"
      align="stretch"
      class="fill-height test_blue pageBg"
    >
      <v-col v-if="!isLoading" class="test_purple mt-n5 pageBg">
        <v-btn large icon class="close-icon" @click="handlerClose()">
          <v-icon large color="#FFF">mdi-close-circle</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" class="d-flex flex-column align-center justify-center">
        <h1 class="text-center white-text" style="margin-bottom: 10px">
          Tak for din bestilling
        </h1>
        <p class="text-center white-text">
          Vi sender dig en sms med <br />
          dine oplysninger
        </p>
        <h4 class="text-center white-text" style="margin-top: 10px">
          Dit ordre nummer er - #{{ datas.publicRef }}
        </h4>
        <h3 class="text-center white-text" style="margin-top: 50px">
          Hvordan var din bestilling
        </h3>
        <div
          style="
            display: flex;
            flex-direction: row;
            justify-content: center;
            padding-top: 20px;
          "
        >
          <div
            v-for="(emoji, index) in emojis"
            :key="index"
            class="text-center"
          >
            <v-icon
              style="padding: 10px"
              size="30"
              large
              color="#FFF"
              @click="handlerRate(index)"
              >{{ emoji }}</v-icon
            >
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  layout: "Public",
  name: "QuickOrderThanks",
  props: {
    propOrderRef: {
      type: String,
      required: true,
    },
  },
  async beforeRouteEnter(to, from, next) {
    const { data } = await axios.get(
      "/app/orders/cart/checkout/" + to.params.orderref
    );

    next((vm) => {
      vm.datas = data.data;
      vm.orderref = to.params.orderref;
      setTimeout(() => {
        vm.isLoading = false;
      }, 500);
    });
  },
  data: () => ({
    isLoading: true,
    datas: null,
    orderref: null,
    tableId: null,
    emojis: [
      "mdi-emoticon-frown",
      "mdi-emoticon-sad",
      "mdi-emoticon-neutral" /* Add more emojis here */,
      "mdi-emoticon-happy",
      "mdi-emoticon-excited",
    ],
  }),
  created() {
    this.fetchOderDetails();
    this.timer = setInterval(this.fetchOderDetails, 60000);
  },
  mounted() {
    this.tableId = this.$route.params.tableId;
  },

  beforeMount() {
    const self = this;
    self.$store.dispatch("guest/removeInfo");
    self.$store.dispatch("delivery/removeDeliveryDetails");
    self.$store.dispatch("delivery/removeDeliveryMethod");
    self.$store.dispatch("guest/removeAddress");
    self.$store.dispatch("guest/removeSessionId");
    self.$store.dispatch("checkout/setTotal", 0);
    self.$store.dispatch("cart/deleteDetails");
    // self.$store.dispatch("checkout/loadDeliveryServices");
    self.$store.dispatch("customer/removeOption");
    self.$store.dispatch("delivery/setOptionDoor", false);
  },
  methods: {
    async fetchOderDetails() {
      if (this?.orderref) {
        const { data } = await axios.get(
          "/app/orders/cart/checkout/" + this.orderref
        );
        // console.log('data',data,'datas',this.datas,this.orderref)
        this.datas = data.data;
      }
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
    handlerClose() {
      this.$router.push({
        name: "Menu",
        params: {
          tableId: this.tableId,
        },
      });
    },
    handlerRate(index) {
      axios
        .post("/app/orders/rate", {
          order_ref: this.orderref,
          system_rating: index,
        })
        .then((res) => {
          console.log(res);
          if (res.data.status === "Success") {
            this.$router.push({
              name: "Menu",
              params: {
                tableId: this.tableId,
              },
            });
            Toast.fire({
              icon: "success",
              title: res.data.message,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: this.$t("errors.error_alert_title"),
              text: res.data.data.message,
              reverseButtons: true,
              confirmButtonText: "ok",
            });
          }
        })
        .catch((e) => {
          Swal.fire({
            icon: "error",
            title: this.$t("errors.error_alert_title"),
            text: e.message,
            reverseButtons: true,
            confirmButtonText: "ok",
          });
        });
    },
  },
  beforeUnmount() {
    this.cancelAutoUpdate();
  },
};
</script>
<style lang="scss">
.pageBg {
  background-color: var(--v-primary-base) !important;
  //background-color: forestgreen !important;
}
.close-icon {
  position: absolute;
  top: 30px;
  right: 10px;
}
.white-text {
  color: #ffffff;
}
</style>
